var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1233 0.39143C15.6211 0.918062 15.6262 1.77736 15.1347 2.31073L6.20556 11L0.865334 6.20514C0.373812 5.67177 0.378907 4.81247 0.876714 4.28584C1.37452 3.75921 2.17653 3.76467 2.66805 4.29803L6.20556 7.1367L13.3319 0.403624C13.8235 -0.129743 14.6255 -0.135202 15.1233 0.39143Z",
    fill: "#54CD84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDone);
export default __webpack_public_path__ + "static/media/status-done.efd1788060bc30978b47afbde4d8bb1c.svg";
export { ForwardRef as ReactComponent };